import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReplyTemplateForm from '../../../components/forms/ReplyTemplateForm';
import { useReplyTemplateApi } from '../../../hooks/useReplyTemplateApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ReplyTemplateDTO } from '../../../services/apiClient';

const ReplyTemplateEdit: React.FC = () => {
  const { getById, edit, isLoading } = useReplyTemplateApi();
  const [entityData, setEntityData] = useState<ReplyTemplateDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Reply Templates', href: '/admin/replytemplates' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ReplyTemplate data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/replytemplates');
    } catch (error) {
      console.error('Error updating ReplyTemplate:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/replytemplates"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ReplyTemplate.Edit'
    >
        {entityData ? (
          <ReplyTemplateForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/replytemplates')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ReplyTemplateEdit;